import { Maybe } from 'ballerina-core'
import { CMSLink } from './cmsLink.state'

export type LinkResponse = { url: string; label: string; kind: LinkKind; isPublished: boolean }

export type LinkKind = 'External' | 'Internal'

export const cmsLinkParser = Maybe.Operations.map(
  ({ isPublished, label, url, kind }: LinkResponse): Maybe<CMSLink> =>
    isPublished ? { label, url, external: kind === 'External' } : undefined
)
